import { CompleteRequestStatus, MatchStatusType, useGetChattingRoomInfo } from "@src/hooks/auctionAgent/chat";

import { useCancelMatch, useTakerCompleteMatch } from "@src/hooks/auctionAgent/match";
import styled from "styled-components";
import MgDialog from "@src/components/Dialog";
import React, { useEffect, useState } from "react";
import { transferToNative } from "@src/lib/WebAppBridge";

import { useChattingRoomFromContext } from "@src/contexts/ChattingRoomContext";
import { MatchServiceType } from "@src/pages/auctionAgent/chatting";
import MatchCompleteNotification from "./MatchCompleteNotification";
import useSSEMatch from "@src/hooks/auctionAgent/sse";
type MatchUserButtonsProps = {
    matchRequestNo: number;
    chattingRoomNo: number;
};

export enum MatchTakerDialogType {
    IDLE = 0,
    CANCEL = 1,
    COMPLETE = 2,
}

const MatchTakerButtons = ({ matchRequestNo, chattingRoomNo }: MatchUserButtonsProps) => {
    const { data: chattingRoomInfo, refetch: refetchChattingRoomInfo } = useGetChattingRoomInfo(chattingRoomNo, true);
    const { chattingRoomFromContext } = useChattingRoomFromContext();
    const { completeRequestStatus: SseCompleteRequestStatus, matchAcceptedAt, denyCompleteMatchRequestAt } = useSSEMatch();
    const { mutate: cancelMatch } = useCancelMatch();
    const { mutate: completeMatch } = useTakerCompleteMatch();

    const [dialogContent, setDialogContent] = useState<React.ReactNode>(null);

    const [dialogType, setDialogType] = useState(MatchTakerDialogType.IDLE);
    const [showConfirmSnackbar, setShowConfirmSnackbar] = useState(false);
    const [isHiding, setIsHiding] = useState(false);

    const handleCancleModal = () => {
        if (!chattingRoomFromContext) return;
        setDialogType(MatchTakerDialogType.CANCEL);
        setDialogContent(
            <ModalBox>
                <ModalTitle>지원 취소</ModalTitle>
                <ModalContent>{`${chattingRoomInfo?.item.itemSubId}의 ${
                    MatchServiceType[chattingRoomFromContext.serviceType]
                } 지원을 취소하시겠어요?`}</ModalContent>
            </ModalBox>,
        );
    };

    const handleCompleteRequest = () => {
        if (!chattingRoomFromContext) return;
        completeMatch(matchRequestNo, {
            onSuccess: () => {
                refetchChattingRoomInfo();
            },
        });

        // setDialogType(MatchTakerDialogType.COMPLETE);
        // setDialogContent(
        //     <ModalBox>
        //         <ModalTitle>완료 확인 요청</ModalTitle>
        //         <ModalContent>
        //             의뢰인 {chattingRoomInfo?.otherUser.name}님의 {MatchServiceType[chattingRoomFromContext.serviceType]} <br />
        //             수행을 완료하셨나요? <br />
        //             완료 확인을 요청하면, 더 이상 채팅은 할 수 없어요.
        //         </ModalContent>
        //     </ModalBox>,
        // );
    };

    const handleOpenReview = () => {
        if (matchRequestNo) {
            transferToNative(JSON.stringify({ matchRequestNo }), "openReview");
        }
    };

    const handleManagePayout = () => {
        if (matchRequestNo) {
            transferToNative(JSON.stringify({ matchRequestNo }), "openPayout");
        }
    };

    useEffect(() => {
        if (showConfirmSnackbar) {
            const timer = setTimeout(() => {
                setIsHiding(true);
                setTimeout(() => {
                    setShowConfirmSnackbar(false);
                    setIsHiding(false);
                }, 10000);
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, [showConfirmSnackbar]);

    useEffect(() => {
        if (SseCompleteRequestStatus === CompleteRequestStatus.완료승인) {
            transferToNative("", "closeWebView");
        }
    }, [SseCompleteRequestStatus]);

    useEffect(() => {
        if (matchAcceptedAt || denyCompleteMatchRequestAt) {
            refetchChattingRoomInfo();
        }
    }, [matchAcceptedAt, denyCompleteMatchRequestAt]);

    if (!chattingRoomFromContext) return null;
    return (
        <>
            {chattingRoomInfo?.matchStatus === MatchStatusType["매치신청"] && (
                <button className="match-button" onClick={handleCancleModal}>
                    지원 취소
                </button>
            )}
            {chattingRoomInfo?.matchStatus === MatchStatusType["진행중"] && (
                <>
                    {chattingRoomInfo.item.completeRequestStatus === CompleteRequestStatus.진행중 && (
                        <button className="match-button" onClick={handleCompleteRequest}>
                            완료 요청하기
                        </button>
                    )}
                    {chattingRoomInfo.item.completeRequestStatus === CompleteRequestStatus.완료대기 && (
                        <MatchCompleteNotification userType="taker" />
                    )}
                </>
            )}
            {chattingRoomInfo?.matchStatus === MatchStatusType["완료"] && (
                <>
                    <button className="match-button" onClick={handleOpenReview}>
                        후기 확인
                    </button>
                    <button className="match-button" onClick={handleManagePayout}>
                        정산 관리
                    </button>
                </>
            )}
            <MgDialog
                open={dialogType !== MatchTakerDialogType.IDLE}
                onCloseView={() => {
                    setDialogType(MatchTakerDialogType.IDLE);
                    // transferToNative("done", "closeWebView");
                }}
                onClickSubmit={() => {
                    if (dialogType === MatchTakerDialogType.CANCEL) {
                        cancelMatch(matchRequestNo, {
                            onSuccess: () => {
                                refetchChattingRoomInfo();
                                transferToNative("", "doneCancelMatch");
                            },
                        });
                    }
                }}
                width="312px"
                cancelText="아니요"
                confirmText="네"
                confirmStyle={{ fontSize: "18px" }}
                cancelStyle={{ fontSize: "18px" }}
            >
                {dialogContent}
            </MgDialog>
            {showConfirmSnackbar && (
                <SnackbarStyle className={isHiding ? "hide" : ""}>내가 담당 매수대리인으로 매칭되었어요!</SnackbarStyle>
            )}
        </>
    );
};

export default MatchTakerButtons;

const ModalBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
    justify-content: center;
`;

const ModalTitle = styled.div`
    font-size: 18px;
    font-weight: 700;
    color: #0c002c;
`;
const ModalContent = styled.div`
    font-size: 16px;
    font-weight: 400;
    color: #0c002c;
    text-align: center;
    line-height: 1.5;
    margin-bottom: 12px;
`;

export const SnackbarStyle = styled.div`
    position: fixed;
    bottom: 62px;
    left: 0;
    width: 100%;
    padding: 14px 0;
    background-color: #dff0ff;
    color: #2275ee;
    text-align: center;
    font-weight: 700;
    font-size: 14px;
    opacity: 1;
    transform: translateY(0);
    transition: all 0.3s ease-in-out;

    &.hide {
        opacity: 0;
        transform: translateY(20px);
    }
`;
